/**
 * This file lists all the keys used in the browser's localStorage that must persist indefinitely.
 * These keys will never be deleted upon logout or when closing the browser or a browser tab.
 */

export const STORAGE_KEYS = {
  LANGUAGE: "restricted-area-selected-language"
};
